'use client'
import { useEffect, useState } from 'react'
import { Button, If } from '..'

import isClient from '@/utils/browser/isClient'
import useClickWithScroll from '@/utils/browser/useClickWithScroll'
import useMediaQuery from '@/utils/browser/getDeviceScreen'

const ButtonFixed = ({
  buttonId,
  elementIdToGo,
  label,
  elementIdEnd,
  elementIdStart
}) => {
  const { onClickItem } = useClickWithScroll()
  const [isVisibleButton, setIsVisibleButton] = useState(false)

  const isMobile = useMediaQuery('mobile')

  const showFixedButton = () => {
    if (!isClient()) return

    const elementEnd = document.getElementById(elementIdEnd)
    const elementStart = document.getElementById(elementIdStart)

    if (!elementEnd || !elementStart) return

    window.addEventListener('scroll', function () {
      const scrollPosition = window.scrollY
      const elementEndRect = elementEnd.getBoundingClientRect()
      const elementEndtopPosition = elementEndRect.top + scrollPosition
      const elementStartRect = elementStart.getBoundingClientRect()

      const isAboveEndElement = scrollPosition <= elementEndtopPosition - 20
      const isBelowStartElement =
        scrollPosition >= elementStartRect.top + scrollPosition

      if (isAboveEndElement && isBelowStartElement) {
        setIsVisibleButton(true)
      } else {
        setIsVisibleButton(false)
      }
    })
  }

  useEffect(() => {
    showFixedButton()
  }, [])

  return (
    <If condition={isMobile && isVisibleButton}>
      <div className="fgt-fixed-button">
        <Button
          variant="primary"
          id={buttonId}
          onClick={() => onClickItem(elementIdToGo, 0)}
        >
          {label}
        </Button>
      </div>
    </If>
  )
}

export default ButtonFixed
